import { Component } from '@angular/core';
import {Header} from '../header/header';
import {Sidenav} from '../sidenav/sidenav';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [Header, Sidenav, RouterOutlet],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  tabs = [
    {name: 'Dashboard', icon: 'dashboard', route: 'dashboard', order: 1, active: false},
    {name: 'Users', icon: 'group', route: 'users', order: 2, active: false},
    {name: 'Chargers', icon: 'ev_station', route: 'chargers', order: 3, active: false},
    {name: 'Financial Reports', icon: 'currency_rupee_circle', route: 'finance', order: 4, active: false},
  ]
}
